// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
// import vConsole from './vconsole'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
/*
import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics)
*/

Vue.config.productionTip = false




// 设置favicon
let favicon = document.createElement('link');
favicon.rel = 'shortcut icon';
favicon.href = 'static/favicon.ico';
document.head.appendChild(favicon);
// Vue.use(ElementUI);

new Vue({
  render: h => h(App),
}).$mount('#app')




// WEBPACK FOOTER //
// ./src/main.js